<template>
    <ul class="menu list-unstyle" :style="{top: position.y + 'px', left: position.x + 'px'}">
        <li class="item" @click="addOpenHem">
            <ButtonCircle>
                <img src="/imgs/hem-icons/open-hem.svg"/>
            </ButtonCircle>
            Open hem
        </li>
        <li class="item" @click="addCloseHem">
            <ButtonCircle>
                <img src="/imgs/hem-icons/close-hem.svg"/>
            </ButtonCircle>
            Close hem
        </li>
        <li class="item" @click="makeFold">
            <ButtonCircle>
                <img src="/imgs/hem-icons/fold.svg"/>
            </ButtonCircle>
            Fold
        </li>
    </ul>
</template>

<script>
    import { mapState, mapMutations, mapActions } from 'vuex';
    import ButtonCircle from "../../../components/ButtonCircle";

    export default {
        name: "ContextMenu",

        components: {
            ButtonCircle,
        },

        emits: [
            'close',
        ],

        props: [
            'id',
            'position',
        ],

        computed: {
            ...mapState('editor', [
                'USER_ACTIONS',
            ]),

        },

        methods: {
            ...mapMutations('editor', [
                'setUserAction',
            ]),

            ...mapActions('editor', [
                'addHem',
                'addFold',
            ]),

            close() {
                this.$emit('close');
            },

            addOpenHem() {
                this.setUserAction(this.USER_ACTIONS.SET_OPEN_HEM);

                this.addHem({pointId: this.id});

                this.close();
            },

            addCloseHem() {
                this.setUserAction(this.USER_ACTIONS.SET_CLOSE_HEM);

                this.addHem({pointId: this.id});

                this.close();
            },

            makeFold() {
                this.setUserAction(this.USER_ACTIONS.SET_FOLD);

                this.addFold({pointId: this.id});

                this.close();
            },

        },

    }
</script>

<style scoped>
    .menu {
        position: absolute;
        z-index: 1;
        top: 0;
        left: 0;
        min-width: 150px;
        padding: 3px 0;
        border: 1px solid #ddd;
        border-radius: 6px;
        font-size: 14px;
        background: #fff;
        box-shadow: 2px 2px 2px #555;
        /*transform: translate(-50%, 30px);*/
    }

    .above {
        transform: translate(0, calc(-100% - 20px));
    }

    .item {
        display: flex;
        align-items: center;
        padding: 2px 5px;
    }

    .item:hover {
        background: #eee;
        cursor: pointer;
    }

    .button-circle {
        margin-right: 10px;
    }

    .button-circle:hover {
        background: #fff;
    }
</style>